import { Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { take } from 'rxjs';

import { ChatEventsService, ExternalEmployeesService, UserService } from '@shared/services';
import { EmployeeDetails, Message, Room } from '@shared/factories';

@Component({
  selector:      'chat-read-only',
  templateUrl: './chat-read-only.component.html',
  host: { class: 'am-flex-column am-flex-half bg-white b-radius-wide c1000-height-max-300-i' },
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ChatReadOnlyComponent implements OnChanges {
  @Input() employee: EmployeeDetails;
  room:      Room;
  myId:      number;

  loading:   DOMHighResTimeStamp = performance.now();
  errorChat: boolean;
  @ViewChild('chatBox') chatBox: ElementRef;
  constructor(
    private chatEventsService:        ChatEventsService,
    private externalEmployeesService: ExternalEmployeesService,
    private userService:              UserService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.employee || !this.employee) return;

    this.myId      = this.userService.currentUserValue.id;
    this.room      = null;
    this.errorChat = !this.chatEnabled;

    if (this.errorChat) this.loading = null;
    else                this.loadChat();
  }

  private get chatEnabled(): boolean {
    let feature = this.userService.currentUserValue?.features?.chat_feature;
    if (feature === true) return true;
    if (!Array.isArray(feature) || !feature.length) return false;

    let location = this.employee.workLocation?.identifier;
    return location != null && feature.some(f => +f === +location);
  }

  private loadChat(): void {
    this.loading = performance.now();
    this.externalEmployeesService.requestEEDashboard<any>(this.employee.id, 'chat').pipe(take(1)).subscribe(
      ({ data }) => {
        setTimeout(() => {
          this.room    = data ? new Room(data, this.myId) : null;
          this.loading = null;
          setTimeout(() => this.scrollBottom());
        }, Math.max(0, (1000 - (performance.now() - this.loading))));
      },
      err => {
        console.error(err);
        this.loading   = null;
        this.errorChat = true;
      }
    );
  }

  private scrollBottom(): void {
    if (this.chatBox?.nativeElement) this.chatBox.nativeElement.scrollTop = this.chatBox.nativeElement.scrollHeight;
  }

  getBubbleStyle(message: Message, nextMessage: Message): string {
    let style = '';
    if      (message.bulkMessageId)      style = 'mla mra mbs';
    else if (this.isOwnMessage(message)) style = 'mla';
    else                                 style = 'mra';

    if      (message.deletedAt)          style += ' b-grey';
    else if (this.isOwnMessage(message)) style += ' bg-blue color-white';
    else                                 style += ' bg-grey';

    if (!message.deletedAt && message.bulkMessageId) style += ' b-orange';
    if (!message.bulkMessageId && nextMessage?.participantId !== message.participantId) style += ' mb-s ' + (this.isOwnMessage(message) ? 'bbr-radius-xxs' : 'bbl-radius-xxs');

    return style;
  }

  isOwnMessage(message: Message): boolean {
    return !message?.bulkMessageId && message?.participantId === this.room?.participants?.find(p => p.userId === this.room.myId)?.id;
  }

  messageIsRead(message: Message): boolean {
    return message?.viewerIds?.includes(this.room.participants.find(p => p.isOwner).id);
  }

  showParticipantName(index:number, message: Message, prevMessage: Message): boolean {
    if (this.isOwnMessage(message))                                      return false;
    if (!index)                                                          return true;
    if (prevMessage?.deletedAt)                                          return true;
    if (prevMessage?.bulkMessageId)                                      return true;
    if (message.participantId       !== prevMessage?.participantId)      return true;
    if (message.createdAt.getDate() !== prevMessage.createdAt.getDate()) return true;
    return false;
  }

  getName(participantId: number): string {
    return this.room.participants?.find(p => p.id === participantId)?.fullName;
  }

  showDate(message: Message, messages: Message[], index: number): boolean {
    return !index || messages[index-1]?.createdAt.getDate() !== message.createdAt.getDate();
  }

  getDateTitle(message: Message): string {
    let today     = new Date().toISOString().slice(0, 10);
    let yesterday = new Date(new Date().setDate(new Date().getDate() - 1)).toISOString().slice(0, 10);;
    if (message.dateString === today    ) return 'Heute';
    if (message.dateString === yesterday) return 'Gestern';
    return message.createdAt.toLocaleDateString('de-DE', {
      weekday: 'long',
      year:    'numeric',
      month:   'long',
      day:     'numeric',
    }).replace('.', '');
  }


  openRoom(): void {
    this.chatEventsService.openRoom(this.room);
  }

}
